import { Tooltip } from '@features/shared/components/Tooltip'
import { InfoIcon } from '@features/shared/icons/icons'

/**
 * A sidebar item's description: a quiet info mark after its name
 * (--sidebar-description-mark), a little darker under the pointer, whose
 * card explains the item when the pointer rests on it. Nothing shows when the
 * item has no description. It sits inside the row's link and only explains:
 * a click still opens the row (a hover card, as on the table selector, not an
 * InfoHint). Raised over a row's link overlay so it takes the hover itself.
 */
export function MenuDescription({
  description,
  placement = 'right',
  className = '',
}: {
  description: string | null | undefined
  /** `right` in a menu; `default` (below) on the rail, whose menus open to the right. */
  placement?: 'right' | 'default'
  className?: string
}) {
  const text = description?.trim()
  if (!text) return null
  return (
    <Tooltip content={text} placement={placement} className={`relative z-10 shrink-0 ${className}`}>
      <span
        aria-label={text}
        className="flex shrink-0 items-center text-[color:var(--sidebar-description-mark)] transition-colors hover:text-[color:var(--sidebar-description-mark-hover)]"
      >
        <InfoIcon size={11} aria-hidden="true" />
      </span>
    </Tooltip>
  )
}
